import React from 'react';
import styles from './info.module.scss';
import { classNames, H2 } from '@tpr/core';
export var Info = function (_a) {
    var _b;
    var children = _a.children, title = _a.title, importantMessage = _a.importantMessage;
    return (React.createElement("div", { className: classNames([
            styles.info,
            (_b = {}, _b[styles['important']] = importantMessage ? true : false, _b),
        ]) },
        importantMessage && (React.createElement("div", { className: styles.importantMessage }, importantMessage)),
        title && React.createElement(H2, { cfg: { mb: 2 } }, title),
        children));
};
//# sourceMappingURL=info.js.map